"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialCapacityPeriod1850 = exports.RegionPartialCapacityPeriod = void 0;
class RegionPartialCapacityPeriod {
    constructor(partialCapacity, regionCapacity, daysOff) {
        this.partialCapacity = partialCapacity;
        this.regionCapacity = regionCapacity;
        this.daysOff = daysOff;
    }
    countWeekDayHolidays() {
        return this.regionCapacity?.holidays?.length || 0;
    }
    countWeekDayTimeOff() {
        return this.daysOff?.length || 0;
    }
    countWorkingDays() {
        return Math.round(this.regionCapacity.weekdays -
            this.countWeekDayHolidays() -
            this.countWeekDayTimeOff());
    }
    countWorkingHours() {
        const region = this.regionCapacity.region;
        const workingHours = region?.workingHours || 8;
        return ((this.countWorkingDays() *
            workingHours *
            (this.partialCapacity?.percent || 0)) /
            100);
    }
}
exports.RegionPartialCapacityPeriod = RegionPartialCapacityPeriod;
class PartialCapacityPeriod1850 {
    constructor(partialCapacity) {
        this.partialCapacity = partialCapacity;
    }
    countWorkingHours() {
        const utilizationHoursTarget = 1850;
        return ((Math.round(utilizationHoursTarget / 12) *
            (this.partialCapacity?.percent || 0)) /
            100);
    }
}
exports.PartialCapacityPeriod1850 = PartialCapacityPeriod1850;
//# sourceMappingURL=RegionPartialCapacityPeriod.js.map